// extracted by mini-css-extract-plugin
export var bodyRow = "_cf-d";
export var cardColumns = "_cf-e";
export var ellipsesOverflow = "_cf-2";
export var flatBottomCorners = "_cf-3";
export var flatTopCorners = "_cf-4";
export var headerActionsDropdown = "_cf-f";
export var headerBottomRow = "_cf-c";
export var headerTopRow = "_cf-b";
export var orderDetailsWrapper = "_cf-0";
export var orderInfoContainer = "_cf-1";
export var productDetails = "_cf-9";
export var productImage = "_cf-5";
export var responsiveTable = "_cf-8";
export var shipmentContainer = "_cf-a";
export var tableBottomLeft = "_cf-6";
export var tableBottomRight = "_cf-7";
export var trackingLink = "_cf-g";